import { createFileRoute } from "@tanstack/react-router";

import { FlowHighlightsSection } from "~/components/feature/flow/components";

export const Route = createFileRoute("/_app/dashboard/flow/highlights")({
  component: RouteComponent,
});

function RouteComponent() {
  return <FlowHighlightsSection />;
}
